import { render, staticRenderFns } from "./collectNew.vue?vue&type=template&id=6bd0b6f6&scoped=true&"
import script from "./collectNew.vue?vue&type=script&lang=js&"
export * from "./collectNew.vue?vue&type=script&lang=js&"
import style0 from "./collectNew.vue?vue&type=style&index=0&id=6bd0b6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0b6f6",
  null
  
)

export default component.exports